import { createFileRoute, Navigate } from "@tanstack/react-router";

const Component = () => {
  return <Navigate to="/consent-solutions" />;
};

const Route = createFileRoute("/")({
  component: () => <Component />,
});

export { Route };
